<oes-modal-dialog
  #sharedExportDialog
  [title]="'files.shared-export.title' | translate"
  [size]="'large'"
  [allowSubmit]="true"
  [activateSubmit]="!canDownload()"
  [submitButtonText]="'files.shared-export.download-button' | translate"
  (submit)="download()"
  (close)="onModalClosed()">
  <form [formGroup]="form" class="shared-export-form">
    <p class="shared-export-intro">
      {{ 'files.shared-export.modal-copy' | translate }}
    </p>

    <div class="shared-export-grid">
      <div class="field-group">
        <label>{{ 'files.shared-export.program-label' | translate }}</label>
        <oes-custom-dropdown
          formControlName="programId"
          [options]="programOptions"
          [mode]="'single'"
          [searchable]="true"
          [loading]="loadingPrograms"
          placeholderKey="files.shared-export.program-placeholder">
        </oes-custom-dropdown>
      </div>

      <div class="field-group">
        <label>{{ 'files.shared-export.association-type-label' | translate }}</label>
        <oes-custom-dropdown
          formControlName="associationType"
          [options]="associationOptions"
          [mode]="'single'"
          [searchable]="false"
          placeholderKey="files.shared-export.association-type-placeholder">
        </oes-custom-dropdown>
      </div>

      <div class="field-group">
        <label>{{ 'files.shared-export.filename-contains-label' | translate }}</label>
        <input
          class="form-control"
          formControlName="filenameContains"
          type="text"
          [placeholder]="'files.shared-export.filename-contains-placeholder' | translate">
      </div>

      <div class="field-group">
        <label>{{ 'files.shared-export.extensions-label' | translate }}</label>
        <input
          class="form-control"
          formControlName="extensionsInput"
          type="text"
          [placeholder]="'files.shared-export.extensions-placeholder' | translate">
      </div>

      <div class="field-group">
        <label>{{ 'files.shared-export.upload-date-mode-label' | translate }}</label>
        <select class="form-control" formControlName="uploadDateMode">
          <option *ngFor="let option of uploadDateModeOptions" [ngValue]="option.value">
            {{ option.labelKey | translate }}
          </option>
        </select>
      </div>

      <div class="field-group">
        <label>{{ 'files.shared-export.form-upload-label' | translate }}</label>
        <select class="form-control" formControlName="formUploadFilter">
          <option *ngFor="let option of formUploadOptions" [ngValue]="option.value">
            {{ option.labelKey | translate }}
          </option>
        </select>
      </div>

      <div class="field-group" *ngIf="isDateControlVisible('uploadDateFrom')">
        <label>{{ 'files.shared-export.upload-date-from-label' | translate }}</label>
        <input
          type="text"
          autocomplete="off"
          class="form-control"
          bsDatepicker
          formControlName="uploadDateFrom"
          [placeholder]="'calendar.format' | translate">
      </div>

      <div class="field-group" *ngIf="isDateControlVisible('uploadDateTo')">
        <label>{{ 'files.shared-export.upload-date-to-label' | translate }}</label>
        <input
          type="text"
          autocomplete="off"
          class="form-control"
          bsDatepicker
          formControlName="uploadDateTo"
          [placeholder]="'calendar.format' | translate">
      </div>
    </div>

    <div class="shared-export-actions">
      <button
        type="button"
        class="btn btn-primary-light"
        [disabled]="!canEstimate()"
        (click)="estimate()">
        {{ 'files.shared-export.estimate-button' | translate }}
      </button>
    </div>

    <div *ngIf="estimateResponse" class="shared-export-estimate">
      <div class="estimate-summary">
        <div>
          <span class="estimate-label">{{ 'files.shared-export.estimate-files' | translate }}</span>
          <strong>{{ estimateResponse.fileCount }}</strong>
        </div>
        <div>
          <span class="estimate-label">{{ 'files.shared-export.estimate-size' | translate }}</span>
          <strong>{{ formatBytes(estimateResponse.totalBytes) }}</strong>
        </div>
      </div>

      <p *ngIf="estimateAllowed" class="estimate-allowed">
        {{ 'files.shared-export.estimate-allowed' | translate }}
      </p>

      <div *ngIf="!estimateAllowed" class="estimate-blocked">
        <p>{{ 'files.shared-export.estimate-blocked' | translate }}</p>
        <ul>
          <li *ngIf="!hasMatchingFiles">{{ 'files.shared-export.estimate-empty' | translate }}</li>
          <li *ngIf="hasMatchingFiles">{{ 'data-room.download-limit.total-size' | translate: { max: '50 GB' } }}</li>
        </ul>
      </div>
    </div>

    <div *ngIf="submitting || polling || downloading" class="shared-export-progress">
      <span class="spinner"></span>
      <span>
        <ng-container *ngIf="submitting">{{ 'files.shared-export.submitting' | translate }}</ng-container>
        <ng-container *ngIf="polling">{{ 'files.shared-export.preparing' | translate }}</ng-container>
        <ng-container *ngIf="downloading">{{ 'files.shared-export.downloading' | translate }}</ng-container>
      </span>
    </div>

    <div *ngIf="inlineError" class="shared-export-inline-error">
      {{ inlineError }}
    </div>

    <p *ngIf="!loadingPrograms && !programOptions.length" class="shared-export-empty-state">
      {{ 'files.shared-export.no-programs' | translate }}
    </p>
  </form>
</oes-modal-dialog>
